<svg
  [style.width]="width()"
  [style.height]="height()"
  viewBox="0 0 20 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect y="0.5" width="20" height="20" rx="10" fill="#092951" />
  <path
    d="M6.00007 11.2667C5.78895 11.2667 5.60851 11.1916 5.45873 11.0413C5.30851 10.8916 5.2334 10.7111 5.2334 10.5C5.2334 10.2889 5.30851 10.1084 5.45873 9.95867C5.60851 9.80845 5.78895 9.73334 6.00007 9.73334H14.0001C14.2112 9.73334 14.3916 9.80845 14.5414 9.95867C14.6916 10.1084 14.7667 10.2889 14.7667 10.5C14.7667 10.7111 14.6916 10.8916 14.5414 11.0413C14.3916 11.1916 14.2112 11.2667 14.0001 11.2667H6.00007Z"
    [attr.fill]="color()"
  />
</svg>
